<template>
  <Loading v-if="showSpinner" />
  <router-view />
</template>

<script>
import { MAIN_ITEM_LOCAL_STORAGE } from './constants'
import { mapGetters } from 'vuex'
import { cleanSession } from './utils/tools'
import Ably from 'ably'

export default {
  data() {
    return {
      ablyData: undefined,
      ablyDataDefault: {
        ably: undefined,
        channel: undefined,
        event: 'App\\Events\\NotifyEvent',
        channelName: 'private:notify.'
      },
      ablyDataCompany: undefined,
      ablyDataDefaultCompany: {
        ably: undefined,
        channel: undefined,
        event: 'App\\Events\\CompanyUpdateEvent',
        channelName: 'private:company.'
      }
    }
  },
  computed: mapGetters({
    showSpinner: 'main/loading'
  }),
  beforeMount() {
    try {
      const permission = Notification.permission
      if (permission === 'default') {
        this.requestAndShowPermission()
      }
    } catch (error) {
      console.error(error)
    }

    const retrievedObject = JSON.parse(
      localStorage.getItem(MAIN_ITEM_LOCAL_STORAGE)
    )
    if (retrievedObject) {
      this.$store.commit('auth/setDataFromLocalStorage', retrievedObject)
      if (retrievedObject?.token) {
        return this.updateUserData()
      }
    }
  },
  methods: {
    requestAndShowPermission() {
      Notification.requestPermission(
        (permission) =>
          permission === 'granted' && this.showInitialNotification()
      )
    },
    showInitialNotification() {
      const title = 'Notificaciones activadas'
      const icon = '/favicon.ico'
      const body = 'Las notificaciones se encuentran activas'
      const notification = new Notification(title, { body, icon })
      notification.onclick = () => {
        notification.close()
        window.parent.focus()
      }
    },
    async updateUserData() {
      try {
        const response = await this.axios.get('/auth/info-by-token', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.$store.commit('auth/setUserData', {
          user: response.data
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
      }
    },
    async setupAbly() {
      return setTimeout(async () => {
        this.ablyData = { ...this.ablyDataDefault }
        this.ablyData.channelName += this.$store?.state?.auth?.user?.id || ''
        const ablyOptions = process.env.VUE_APP_ABLY_KEY
          ? { key: process.env.VUE_APP_ABLY_KEY }
          : {
              authUrl: `${process.env.VUE_APP_BASE_API_URL}/broadcasting/auth`,
              authHeaders: {
                Authorization: `Bearer ${
                  this.$store?.state?.auth?.token || ''
                }`,
                Accept: 'application/json'
              }
            }
        this.ablyData.ably = new Ably.Realtime(ablyOptions)
        this.ablyData.channel = this.ablyData.ably.channels.get(
          this.ablyData.channelName
        )
        this.ablyData.channel.subscribe((message) => {
          const response = typeof message.data === 'string' ? JSON.parse(message.data) : message.data
          if (response.type === 'MULTI_QUOTATION_CHANGE_PRICE') {
            localStorage.removeItem('cartData')
          }
          this.$store.commit('main/setBellMessages', [
            ...(this.$store.state?.main?.bellMessages || []),
            response
          ])
          const key =
            response?.type === 'QUOTATION'
              ? response.data?.quotation_id
              : response.data?.id
          return (
            (response?.type === 'QUOTATION' ||
              response?.type === 'STATUS_QUOTATION' ||
              response?.type === 'PRICE_QUOTATION') &&
            (this.$route.name !== 'quotation' ||
              (this.$route.name === 'quotation' &&
                +this.$route.params?.id !== key)) &&
            this.showNotifyQuotation(response)
          )
        })
      }, 1000)
    },
    async removeAbly() {
      try {
        this.$store.commit('main/setBellMessages', [])
        if (this.ablyData?.channel) {
          this.ablyData.channel.unsubscribe()
        }
        if (this.ablyData?.ably) {
          this.ablyData.ably.close()
          this.ablyData = undefined
        }
      } catch (error) {
        console.error(error)
      }
    },
    async setupAblyCompany() {
      return setTimeout(async () => {
        this.ablyDataCompany = { ...this.ablyDataDefaultCompany }
        this.ablyDataCompany.channelName +=
          this.$store?.state?.auth?.company?.id || ''
        const ablyOptions = process.env.VUE_APP_ABLY_KEY
          ? { key: process.env.VUE_APP_ABLY_KEY }
          : {
              authUrl: `${process.env.VUE_APP_BASE_API_URL}/broadcasting/auth`,
              authHeaders: {
                Authorization: `Bearer ${
                  this.$store?.state?.auth?.token || ''
                }`,
                Accept: 'application/json'
              }
            }
        this.ablyDataCompany.ably = new Ably.Realtime(ablyOptions)
        this.ablyDataCompany.channel =
          this.ablyDataCompany.ably.channels.get(
            this.ablyDataCompany.channelName
          )
        this.ablyDataCompany.channel.subscribe(
          (message) => {
            const response = typeof message.data === 'string' ? JSON.parse(message.data) : message.data
            this.$store.commit('auth/setSessionData', {
              token: this.$store?.state?.auth?.token,
              user: this.$store?.state?.auth?.user,
              company: response.company
            })

            return true
          }
        )
      }, 1000)
    },
    async removeAblyCompany() {
      try {
        this.$store.commit('main/setBellMessages', [])
        if (this.ablyDataCompany?.channel) {
          this.ablyDataCompany.channel.unsubscribe()
        }
        if (this.ablyDataCompany?.ably) {
          this.ablyDataCompany.ably.close()
          this.ablyDataCompany = undefined
        }
      } catch (error) {
        console.error(error)
      }
    },
    showNotifyQuotation(response) {
      try {
        const title = 'Mensaje recibido'
        const icon = '/favicon.ico'
        let body
        let key
        switch (response.type) {
          case 'QUOTATION':
            body = `Te han enviado un mensaje por la cotización ${response.data?.quotation_id}`
            key = response.data?.quotation_id
            break
          case 'STATUS_QUOTATION':
            body = `El estatus de la cotización ${response.data?.id} ha cambiado`
            key = response.data?.id
            break
          case 'PRICE_QUOTATION':
            body = `El precio de la cotización ${response.data?.id} ha cambiado`
            key = response.data?.id
            break
          default:
            break
        }
        const notification = new Notification(title, { body, icon })
        notification.onclick = () => {
          this.$router.push({
            name: 'quotation',
            params: { id: key }
          })
          notification.close()
          window.parent.focus()
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    '$store.state.auth.token': async function () {
      if (this.$store.state.auth.token) {
        this.setupAbly()
        this.setupAblyCompany()
      } else {
        this.removeAbly()
        this.removeAblyCompany()
      }
    }
  }
}
</script>
